<template>
        <b-navbar type="is-white" spaced shadow centered>
            <template #start>
                <div v-for="(menu, index) in menus" v-bind:key="menu._id">
                    <template v-if="menu.SousMenu.length">
                        <b-navbar-dropdown v-bind:label="menu.Label" v-bind:data-index="index">
                            <div v-for="p in sortFunc(menu.SousMenu)" v-bind:key="p._id">
                                <b-navbar-item v-if="!p.Cacher" v-bind:href="'/' + p.Lien">
                                    {{ p.Label | capitalize }}
                                </b-navbar-item>
                            </div>
                        </b-navbar-dropdown>
                    </template>
                    <template v-else>
                        <b-navbar-item v-bind:href="'/' + menu.Lien">
                            {{ menu.Label | capitalize }}
                        </b-navbar-item>
                    </template>
                </div>
            </template>

            <template #end>
            <b-navbar-item v-bind:href="'/page/contact'">
                Contact
            </b-navbar-item>
        </template>
        </b-navbar>
</template>
<script>
const axios = require('axios');
export default {
    data: function() {
        return {
            error: null,
            menus: null
        }
    },
    name: 'Menu2',
    props: {
        msg: String
    },
    created() {
        this.fetchMenu()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchMenu',
    },

    methods: {
        sortFunc: function (sousmenu){
          return sousmenu.slice().sort(function(a, b){
            return (a.Ordre > b.Ordre) ? 1 : -1;
          });
        },
        fetchMenu() {
            var vm = this
            //var fetchurl = this.$api_url_menu
            var fetchurl = this.$api_url_menu+'&sort[Colonne]=1&filter[Cacher]=0&populate=1'
            axios({
                    method: 'get',
                    url: fetchurl,
                    /*headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        populate: 1,
                        sort: { Colonne: 1 },
                        filter: { Cacher: 0 },
                    })*/
                })
                .then(function(response) {
                    if (response.data.entries.length > 0) {
                        vm.menus = response.data.entries
                        vm.error = null
                    } else {
                        vm.menus = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    vm.error = 'erreur'
                })
        },

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-start--centered {
    flex-grow: 1;
    justify-content: center;
}
.navbar-item{
    font-size: 13pt;
}
.navbar-link:hover{
    /*background-color: #fafafa !important;*/
}

.navbar{
    border-top: 5px solid red;
    box-shadow: 0 1px 3px -2px gray;
}
</style>


<style type="text/css">
    div.navbar-dropdown{
        border-radius: 0px !important;
    }
</style>